export default "__VITE_ASSET__BqXWw3yw__"